<template>
    <div>
    <v-container fluid style="padding:20px;">
        <v-row>
            <v-col>
                <h5>Legal notice</h5>
           </v-col>
        </v-row>
        <v-row>
            <v-col>
                This site is provided by:

                University Medical Center Göttingen (UMG)
            </v-col>
        </v-row>
    </v-container>
    </div>
</template>
